<script>
import { defineCustomElement } from "vue";
import { createPinia, setActivePinia } from "pinia";
import studentJournalButton from "./modals/studentJournalButton.ce.vue";
import journalButton from "./journalButton.ce.vue";

setActivePinia(createPinia());

const JournalButton = defineCustomElement(journalButton);
const StudentJournalButton = defineCustomElement(studentJournalButton);

if (!customElements.get("journal-button")) {
	customElements.define("journal-button", JournalButton);
}
if (!customElements.get("student-journal-button")) {
	customElements.define("student-journal-button", StudentJournalButton);
}

export default {};
</script>
